export const loadCurrentMenuItem = (itemtype, item) => {
    return {
        type: 'LOAD_MENU_ITEM',
        itemtype,
        item
    };
};

export const currentMenuItemError = (error) => {
    return {
        type: 'MENU_ITEM_ERROR',
        error
    };
};